let context

export default {
    get(){
        return context
    },
    set(ctx){
        return context = ctx
    }
}